import styles from './index.css';

import * as React from 'react';
import classNames from 'classnames';
import {TTextProps} from '../definitions';

export const Input = ({onUpdate, domId, label, value, isInvalid, className}: TTextProps) => {
	const onChange = (e: React.FormEvent<HTMLInputElement>) =>
		onUpdate(e.currentTarget.value);

	return (
		<div
			data-is-invalid={isInvalid ? "1" : "0"}
			className={classNames(
				styles.input,
				isInvalid && styles.isInvalid,
				className
			)}
		>
			{
				Boolean(label) &&
					<label
						htmlFor={domId}
						className={styles.label}
					>
						{label}
					</label>
			}
			<input
				value={value}
				onChange={onChange}
				type="text"
				id={domId}
				name={domId}
			/>
		</div>
	);
}
